import { render, staticRenderFns } from "./clauseList.vue?vue&type=template&id=333a4790&scoped=true"
import script from "./clauseList.vue?vue&type=script&lang=js"
export * from "./clauseList.vue?vue&type=script&lang=js"
import style0 from "./clauseList.vue?vue&type=style&index=0&id=333a4790&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333a4790",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333a4790')) {
      api.createRecord('333a4790', component.options)
    } else {
      api.reload('333a4790', component.options)
    }
    module.hot.accept("./clauseList.vue?vue&type=template&id=333a4790&scoped=true", function () {
      api.rerender('333a4790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/settings/components/clauseList.vue"
export default component.exports